import React from 'react'
import { FormattedMessage } from 'gatsby-plugin-intl'

const InovapayWallet = ({ register, errors, touchedFields }) => {
  return (
    <>
      <div>
        <label htmlFor='userLogin' className='pb-2 pt-4'>
          <FormattedMessage id='payments.userLogin' />
        </label>
        <input
          name='userLogin'
          className={`${errors.userLogin ? 'invalid' : ''} ${
            !errors.userLogin && touchedFields.userLogin ? 'valid' : ''
          }`}
          {...register('userLogin', {
            required: true,
          })}
        />
      </div>
      <div>
        <label htmlFor='userSecureId' className='pb-2 pt-4'>
          <FormattedMessage id='payments.userSecureId' />
        </label>
        <input
          type='password'
          name='userSecureId'
          className={`${errors.userSecureId ? 'invalid' : ''} ${
            !errors.userSecureId && touchedFields.userSecureId ? 'valid' : ''
          }`}
          {...register('userSecureId', {
            required: true,
          })}
        />
      </div>
    </>
  )
}

export default InovapayWallet
